module.exports = __webpack_public_path__ + "media/images/icons/info-circle-890cc610547a4b32cf271d6391bd2d38.svg";